import { API_BASE_URL } from "../../config";

/** Resolve relative asset paths against the API origin. */
export function resolveAssetUrl(raw) {
  if (!raw || typeof raw !== "string") return null;
  const u = raw.trim();
  if (!u) return null;
  if (u.startsWith("http://") || u.startsWith("https://")) return u;
  const base = String(API_BASE_URL || "").replace(/\/$/, "");
  return u.startsWith("/") ? `${base}${u}` : `${base}/${u}`;
}
